export const TEL_MODE_STATUS = {
  PAUSED: 'paused', // 暂停中
  CONNECTING: 'connecting', // 连接中
  GREET_REPLYING: 'greetReplying', // 开场白回复中
  WAIT_TO_SPEAK: 'waitToSpeak', // 请开始说话
  SPEAKING: 'speaking', // 说话中
  THINKING: 'thinking', // 正在思考中
  REPLYING: 'replying', // 机器人回复中
  BAN: 'ban', // 永久封禁
  NETWORK_ERR: 'networkError', // 网络异常
  SERVER_ERR: 'serverError', // 服务器异常
  PERMISSION_ERR: 'permissionError', // 权限异常
} as const;

export type TelModeStatus = (typeof TEL_MODE_STATUS)[keyof typeof TEL_MODE_STATUS];

export const speakingHintTexts = ['正在聆听', '说话停止时会自动发送', '点击这里也可以发送'];

export const ERROR_CODE = {
  TEMPORARY_BAN: ['1200034', '1200033', '1200032', '18', '19'], // 临时封禁 停止播放
  PERMANENT_BAN: ['401', '1200035'], // 永久封禁 停止播放
  CHANGE_TOPIC: ['13'], // 换个话题 停止正常播放，播放异常音频
  NEW_CHAT: ['1000031'], // 开启新话题 停止正常播放，播放异常音频
  PREV_REQUEST_UNFINISHED: ['1000013'], // 上一次请求未完成
  NEED_LOGIN: ['1000048'], // 需要登录
};

export const RECORD_STATUS = {
  USER_GUIDE: 'userGuide', // 引导页面
  READY_RECORD: 'readyRecord', // 准备录制中
  FAIL_RERECORD: 'failReRecord', // 校验失败 重新准备录制
  RECORDING: 'recording', // 录制中
  CHECKING: 'checking', // 校验中
  CREATE_SUCCESS: 'createSuccess', // 创建成功
} as const;

export type VoiceRecordStatusEnum = (typeof RECORD_STATUS)[keyof typeof RECORD_STATUS];

export const DRAWER_TYPE = {
  VOICE_LIST: 'voiceList',
  RECORD: 'record',
} as const;
export type DrawerTypeEnum = (typeof DRAWER_TYPE)[keyof typeof DRAWER_TYPE];
